import { EventTypes } from 'redux-segment';

import { CURRENT_SEGMENT_EVENT_VERSION } from 'helpers/segmentV2';

export const viewedSetting = view_name => ({
  type: 'SETTINGS_VIEWED',
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          view_name
        }
      }
    }
  }
});

export const viewedMeetingListing = view_name => ({
  type: 'MEETING_LISTED',
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          view_name
        }
      }
    }
  }
});

export const viewedCallListing = view_name => ({
  type: 'CALL_LISTED',
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          view_name
        }
      }
    }
  }
});

export const trackMeetingRelatedEvents = (type, meeting_id) => ({
  type,
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          meeting_id
        }
      }
    }
  }
});

export const trackViewRelatedEvents = (type, view_name) => ({
  type,
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          view_name
        }
      }
    }
  }
});

export const trackSegmentEvents = ({ type, ...properties }) =>
  // Dispatch to segment
  ({
    type,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          properties: {
            ...properties,
            version: CURRENT_SEGMENT_EVENT_VERSION
          }
        }
      }
    }
  });

export const identifySegmentEvent = eventPayload => {
  window?._hsq?.push([
    'identify',
    {
      email: eventPayload?.email
    }
  ]);
  return {
    type: 'LOGIN',
    meta: {
      analytics: {
        eventType: EventTypes.identify,
        eventPayload: { ...eventPayload }
      }
    }
  };
};

// Rev Intel Segment Trackers

export const forecastViewCreated = ({
  viewName,
  viewId,
  forecastViewType
}) => ({
  type: 'FORECAST_VIEW_CREATED',
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          view_name: viewName,
          view_id: viewId,
          forecast_view_type: forecastViewType
        }
      }
    }
  }
});

export const forecastViewUpdated = ({
  viewName,
  viewId,
  savedViewId,
  forecastViewType
}) => ({
  type: 'FORECAST_VIEW_UPDATED',
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          view_name: viewName,
          view_id: viewId,
          saved_view_id: savedViewId,
          forecast_view_type: forecastViewType
        }
      }
    }
  }
});

export const dealViewCreated = ({ viewName, viewId }) => ({
  type: 'DEAL_VIEW_CREATED',
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          view_name: viewName,
          view_id: viewId
        }
      }
    }
  }
});

export const forecastViewPinned = ({
  viewName,
  viewId,
  pinnedViewId,
  forecastViewType
}) => ({
  type: 'FORECAST_VIEW_PINNED',
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          view_name: viewName,
          view_id: viewId,
          pinned_view_id: pinnedViewId,
          forecast_view_type: forecastViewType
        }
      }
    }
  }
});

export const forecastViewDeleted = ({
  viewName,
  viewId,
  savedViewId,
  forecastViewType
}) => ({
  type: 'FORECAST_VIEW_DELETED',
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          view_name: viewName,
          view_id: viewId,
          saved_view_id: savedViewId,
          forecast_view_type: forecastViewType
        }
      }
    }
  }
});

export const forecastViewUnpinned = ({
  viewName,
  viewId,
  pinnedViewId,
  forecastViewType,
  forecastPeriod
}) => ({
  type: 'FORECAST_VIEW_UNPINNED',
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          view_name: viewName,
          view_id: viewId,
          pinned_view_id: pinnedViewId,
          forecast_view_type: forecastViewType,
          ...(forecastPeriod ? { forecast_period: forecastPeriod } : {})
        }
      }
    }
  }
});

export const dealViewed = ({ dealId }) => ({
  type: 'DEAL_VIEWED',
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          deal_id: dealId
        }
      }
    }
  }
});

export const dealListed = ({ viewId, viewName, filters }) => ({
  type: 'DEAL_LISTED',
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        properties: {
          view_id: viewId,
          view_name: viewName,
          filters
        }
      }
    }
  }
});

export const dealQuickViewTabViewed = ({ type }) => ({
  type,
  meta: { analytics: { eventType: EventTypes.track } }
});
